<template>
  <div class="repay-item">
    <div class="repay-item-header">
      <div class="left">
        <span class="number">{{$t('message.repay.orderId')}}：{{order.orderId}}</span>
      </div>
      <div class="right">
        <span class="status" :style="`color: ${COLOR_STATUS[order.repaymentStatus]}`">{{order.repaymentStatusText}}</span>
        <img :src="arrow" style="width: 16px; vertical-align: middle"  alt=">">
      </div>
    </div>
    <div class="repay-item-detail">
      <img style="width: 24vw; height: 24vw" :src="order.img" alt="车照片">
      <div class="desc">
        <div class="text">
          <div class="brand">
            <p>{{order.brandSeries}}</p>
            <p>{{order.autoModelStyle}}</p>
          </div>
          <span class="count">x1</span></div>
        <div class="price">{{order.monthPay}}x{{order.periods}}{{$t('message.repay.period')}}</div>
        <div class="btn">{{$t('message.repay.handle_pay')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import arrow from '@/assets/app/arrow-right.svg';
const COLOR_STATUS = {
  0: '#000000',
  1: '#F6BC50',
  2: '#F35A3E',
  3: '#3682F8',
  4: '#F6BC50',
  5: '#F35A3E'
};
export default {
  name: 'repay-item',
  props: {
    order: {
      type: Object
    }
  },
  data () {
    return {
      arrow,
      COLOR_STATUS
    };
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
  .repay-item{
    background-color: #fff;
    .repay-item-header {
      border-bottom: 1px solid #E0E0E0;
      display: flex;
      justify-content: space-between;
      padding: 30px;
      .left {
        .number {
          font-size: 26px;
        }
      }
      .right {
        font-size: 30px;
        vertical-align: middle;
        .icon {
          display: inline-block;
          width: 28px;
          vertical-align: middle;
          color: #7F7F7F;
          margin-left: 10px;
        }
        .status {
          font-family: PingFangSC-Medium;
          font-size: 30px;
        }
      }
    }
    .thumbnail {
      display: inline-block;
      width: 180px;
      height: 180px;
    }
    .repay-item-detail {
      position: relative;
      display: flex;
      padding: 30px;
      justify-content: flex-start;
      .thumbnail {
        display: inline-block;
        width: 180px;
        height: 180px;
      }
      .desc {
        flex: 1;
        margin-left: 30px;
        .text {
          padding: 10px 0;
          display: flex;
          justify-content: space-between;
          font-family: PingFangSC-Medium;
          font-size: 30px;
          color: #000000;
          .brand {
            flex: 1;
            line-height: 45px;
          }
          .count {
            width: 74px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            font-family: PingFangSC-Regular;
            font-size: 26px;
            color: #7F7F7F;
          }
        }
        .price {
          font-family: PingFangSC-Medium;
          font-size: 42px;
          color: #E28808;
        }
        .btn {
          position: absolute;
          right: 30px;
          bottom: 30px;
          width: 160px;
          height: 60px;
          background:rgba(255,225,2,1);
          border-radius: 30px;
          font-size: 24px;
          font-family: PingFangSC-Medium,PingFang SC;
          font-weight: 500;
          color: rgba(0,0,0,1);
          line-height: 60px;
          text-align: center;
        }
      }
    }
  }
</style>
